type FormatMap = { [key: string]: string };

export enum PointsBehaviorValue {
    ATTENTION_INSTAGRAM = 'ATTENTION_INSTAGRAM', // ("关注 Instagram"),
    ATTENTION_TITTOK = 'ATTENTION_TITTOK', // ("关注 TitTok"),
    ATTENTION_X = 'ATTENTION_X', // ("关注 X"),
    ATTENTION_YOUTUBE = 'ATTENTION_YOUTUBE', // ("关注 Youtube"),
    ATTENTION_FACEBOOK = 'ATTENTION_FACEBOOK', // ("关注 Facebook"),
    ATTENTION_LINE = 'ATTENTION_LINE', // ("关注 LINE"),
    ATTENTION_KAKOO = 'ATTENTION_KAKOO', // ("关注 Kakoo"),
    JOIN_FACEBOOK = 'JOIN_FACEBOOK', // ("加入群组-Facebook"),
    JOIN_KAKOO = 'JOIN_KAKOO', // ("加入群组-Kakoo"),
    COMMUNITY_SEND_CONTENT = 'COMMUNITY_SEND_CONTENT', // ("社区发帖"),
    COMMUNITY_SEND_COMMENT = 'COMMUNITY_SEND_COMMENT', // ("社区评论"),
    COMMUNITY_UPVOTE = 'COMMUNITY_UPVOTE', // ("社区点赞"),
}

export type PointsBehaviorProps = {
    [key in keyof typeof PointsBehaviorValue]: {
        value: string;
        isFinish: boolean;
    };
};

export const dateFormatMap: FormatMap = {
    us: 'DD/MM/YYYY',
    jp: 'YYYY/MM/DD',
};

export const dateTimeFormatMap: FormatMap = {
    us: 'DD/MM/YYYY HH:mm:ss',
    jp: 'YYYY/MM/DD HH:mm:ss',
};
